<div
  class="inline-flex items-center justify-between space-x-md rounded-3 border border-grey-200 p-lg"
  [ngClass]="{'-m-px border-2 border-orange-500': hasWarning, 'w-full': !!label}"
>
  @if (label) {
    <label [for]="id">{{ label }}</label>
  }
  <span class="flex space-x-xs">
    <button
      type="button"
      class="btn h-[30px]! w-[30px]! rounded-1! btn-secondary p-0!"
      [disabled]="(control?.value || 0) <= min"
      (click)="decrement()"
      data-testid="decrement"
    >
      <fa-icon [icon]="minus"></fa-icon>
    </button>
    <input
      #inputElement
      class="w-8 text-center"
      [id]="id"
      type="number"
      [formControl]="control | bgoAsFormControl"
      [name]="controlName"
      [attr.data-testid]="id"
      [valueAsNumber]="defaultDisplayValue"
    />
    <button
      type="button"
      class="btn h-[30px]! w-[30px]! rounded-1! btn-secondary p-0!"
      [disabled]="(control?.value || 0) >= max"
      (click)="increment()"
      data-testid="increment"
    >
      <fa-icon [icon]="plus"></fa-icon>
    </button>
  </span>
</div>
@if (isControlInvalid(control)) {
  <div class="mt-2xs ml-md error">
    <ng-content select="[content=error]"></ng-content>
  </div>
}
